import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const CancellationIdCardSearchPersonCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Ricerca Persona - Annullamento Carta Identità',
    path: '/sportello/annullamento-carta',
  },
];

export const CancellationIdCardCrumbs = [
  ...CancellationIdCardSearchPersonCrumbs,
  {
    name: 'Annullamento Carta Identità',
    path: '/sportello/annullamento-carta/annulla',
  },
];
